export const createImage = (url) =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener("load", () => resolve(image));
    image.addEventListener("error", (error) => reject(error));
    image.setAttribute("crossOrigin", "anonymous");
    image.src = url;
  });

export function getRadianAngle(degreeValue) {
  return (degreeValue * Math.PI) / 180;
}

export function rotateSize(width, height, rotation) {
  const rotRad = getRadianAngle(rotation);
  return {
    width: Math.abs(Math.cos(rotRad) * width) + Math.abs(Math.sin(rotRad) * height),
    height: Math.abs(Math.sin(rotRad) * width) + Math.abs(Math.cos(rotRad) * height),
  };
}

export default async function getCroppedImg(
  imageSrc,
  pixelCrop,
  rotation = 0,
  flip = { horizontal: false, vertical: false }
) {
  const image = await createImage(imageSrc);
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  if (!ctx) return null;

  const rotRad = getRadianAngle(rotation);
  const { width: bBoxWidth, height: bBoxHeight } = rotateSize(image.width, image.height, rotation);

  canvas.width = Math.max(bBoxWidth, pixelCrop.x + pixelCrop.width);
  canvas.height = Math.max(bBoxHeight, pixelCrop.y + pixelCrop.height);

  ctx.translate(bBoxWidth / 2, bBoxHeight / 2);
  ctx.rotate(rotRad);
  ctx.scale(flip.horizontal ? -1 : 1, flip.vertical ? -1 : 1);
  ctx.translate(-image.width / 2, -image.height / 2);
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  ctx.drawImage(image, 0, 0);

  const outputCanvas = document.createElement("canvas");
  outputCanvas.width = pixelCrop.width;
  outputCanvas.height = pixelCrop.height;
  const outputCtx = outputCanvas.getContext("2d");
  if (!outputCtx) return null;

  const sourceX = Math.max(0, Math.min(pixelCrop.x, canvas.width - 1));
  const sourceY = Math.max(0, Math.min(pixelCrop.y, canvas.height - 1));
  const sourceWidth = Math.min(pixelCrop.width, canvas.width - sourceX);
  const sourceHeight = Math.min(pixelCrop.height, canvas.height - sourceY);
  const offsetX = pixelCrop.x < 0 ? -pixelCrop.x : 0;
  const offsetY = pixelCrop.y < 0 ? -pixelCrop.y : 0;

  outputCtx.fillStyle = "#FFFFFF";
  outputCtx.fillRect(0, 0, outputCanvas.width, outputCanvas.height);

  outputCtx.drawImage(
    canvas,
    sourceX, sourceY, sourceWidth, sourceHeight,
    offsetX, offsetY, sourceWidth, sourceHeight
  );

  return new Promise((resolve, reject) => {
    outputCanvas.toBlob((file) => {
      if (file) resolve(file);
      else reject(new Error("Failed to create blob"));
    }, "image/png");
  });
}
